import Component from './component'

const CategorySlider = Component

export default CategorySlider
